import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-quiz-drawer',
  templateUrl: './quiz-drawer.component.html',
  styleUrls: ['./quiz-drawer.component.scss']
})
export class QuizDrawerComponent implements OnInit {
  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  showProofModal = false;

  constructor() { }

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  ngOnInit() { }

  close() {
    this.closed.emit();
  }

  takeQuiz(url: string) {
    window.open(url, '_self');
  }

  setTime(date: any): Date {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: string): string {
    const month = Number(date.substring(5, 7).replace(/^0+/, ''));
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[month - 1]} ${day}, ${year}`;
  }

  getStatus(check: any, completedBy: string, creationDate: string, startDate: string): string {
    const lang = localStorage.getItem('selectedLanguage');
    let value = '';
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    return value;
  }
}
